import { useTranslation } from "react-i18next";
import { PartnerProvisionApi } from "../../../../../../services/Api/Partner/partnerTypes";

export const DrawSubscriptionDetails = (provision: PartnerProvisionApi) => {
	const { t } = useTranslation("admin");

	const result: string[] = [];
	if (provision.source) result.push(provision.source);
	if (provision.billing_period_type)
		result.push(t(`enums.provisions.period.${provision.billing_period_type}`, { ns: "admin" }));
	return result.join(", ");
};
